import { Component, Input } from '@angular/core';

@Component({
  selector: 'gains-input-title',
  standalone: false,
  templateUrl: './gains-input-title.component.html',
  styleUrl: './gains-input-title.component.scss'
})
export class GainsInputTitleComponent {
  @Input() label?: string;
  @Input() required?: boolean;
  @Input() infoTooltip?: string;
  @Input() for?: string;
}
